import React, { useState } from 'react';
import { C, R, SHADOW, fmt } from '../tokens.js';
import { Card, Btn, BkHdr, Badge, Divider, SPill } from '../components/ui.jsx';
import { D } from '../mock-data.js';

export const OrdersScreen = ({ navigate }) => {
  const [tab, setTab] = useState('orders');
  const orders = D.orders;
  const bookings = D.bookings;
  return (
    <div className="fade-in" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '20px 16px 0', background: C.bg }}>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: C.text, marginBottom: 14, letterSpacing: -0.3 }}>Activity</h2>
        <div style={{ display: 'flex', background: '#f5f5f4', borderRadius: R.lg, padding: 4, marginBottom: 14, gap: 4 }}>
          {[{ id: 'orders', l: `Orders (${orders.length})` }, { id: 'bookings', l: `Bookings (${bookings.length})` }].map(t => {
            const on = tab === t.id;
            return (
              <button key={t.id} onClick={() => setTab(t.id)} style={{ flex: 1, padding: '10px 12px', borderRadius: R.md, border: 'none', background: on ? C.white : 'transparent', color: on ? C.primary : C.textMed, fontSize: 13, fontWeight: 800, cursor: 'pointer', boxShadow: on ? '0 1px 3px rgba(28,25,23,.08)' : 'none', transition: 'all .18s', letterSpacing: 0.1 }}>{t.l}</button>
            );
          })}
        </div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '0 16px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {tab === 'orders' && orders.map(o => (
          <Card key={o.id} onClick={() => navigate('order-detail', { order: o })} style={{ cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, gap: 10 }}>
              <div style={{ minWidth: 0, flex: 1 }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: C.textMed, letterSpacing: 0.4, fontVariantNumeric: 'tabular-nums' }}>#{o.id}</p>
                <p style={{ fontSize: 11, color: C.textMed, marginTop: 2 }}>{o.date}</p>
              </div>
              <SPill status={o.status} />
            </div>
            <p style={{ fontSize: 15, fontWeight: 800, color: C.text, marginBottom: 2, letterSpacing: -0.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{o.branchName}</p>
            <p style={{ fontSize: 12, color: C.textMed, marginBottom: 12, lineHeight: 1.4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{o.items.map(i => `${i.name} × ${i.qty}`).join(', ')}</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 14, fontWeight: 800, color: C.primary, fontVariantNumeric: 'tabular-nums' }}>{fmt(o.totalP)}</span>
              {o.status === 'out_for_delivery' ? <Badge bg={C.infoBg} color={C.info} sm>🛵 {o.eta}</Badge> : <span style={{ fontSize: 12, fontWeight: 700, color: C.textMed }}>View →</span>}
            </div>
          </Card>
        ))}
        {tab === 'bookings' && bookings.map(b => (
          <Card key={b.id} onClick={() => navigate('booking-detail', { booking: b })} style={{ cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, gap: 10 }}>
              <div style={{ minWidth: 0, flex: 1 }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: C.textMed, letterSpacing: 0.4, fontVariantNumeric: 'tabular-nums' }}>#{b.id}</p>
                <p style={{ fontSize: 11, color: C.textMed, marginTop: 2 }}>{b.date} · {b.slot}</p>
              </div>
              <SPill status={b.status} />
            </div>
            <p style={{ fontSize: 15, fontWeight: 800, color: C.text, marginBottom: 2, letterSpacing: -0.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{b.branchName}</p>
            <p style={{ fontSize: 12, color: C.textMed, marginBottom: 12, lineHeight: 1.4 }}>{b.service} · ⏱ {b.duration} min</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 14, fontWeight: 800, color: C.primary, fontVariantNumeric: 'tabular-nums' }}>
                {fmt(b.totalP)}
                {b.advancePaidP > 0 && <span style={{ fontSize: 11, fontWeight: 500, color: C.textMed, marginLeft: 4 }}>({fmt(b.advancePaidP)} paid)</span>}
              </span>
              <span style={{ fontSize: 12, fontWeight: 700, color: C.textMed }}>View →</span>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export const OrderDetailScreen = ({ order: o, goBack }) => {
  const [cancelled, setCancelled] = useState(false);
  const stepOrder = ['pending_payment', 'confirmed', 'preparing', 'out_for_delivery', 'delivered'];
  const curIdx = stepOrder.indexOf(o.status);
  const canCancel = ['confirmed', 'preparing'].includes(o.status) && !cancelled;
  const labels = { pending_payment: 'Payment confirmed', confirmed: 'Order confirmed', preparing: 'Preparing your order', out_for_delivery: 'Out for delivery', delivered: 'Delivered' };
  return (
    <div className="fade-in" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <BkHdr title="Track order" onBack={goBack} />
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px 16px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        <Card>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 11, fontWeight: 700, color: C.textMed, letterSpacing: 0.4, fontVariantNumeric: 'tabular-nums' }}>#{o.id}</span>
            <SPill status={o.status} />
          </div>
          <p style={{ fontSize: 17, fontWeight: 800, color: C.text, marginBottom: 4, letterSpacing: -0.3 }}>{o.branchName}</p>
          <p style={{ fontSize: 12, color: C.textMed }}>{o.date} · <span style={{ fontVariantNumeric: 'tabular-nums', color: C.text, fontWeight: 700 }}>{fmt(o.totalP)}</span></p>
          {o.status === 'out_for_delivery' && o.eta && (
            <div style={{ marginTop: 14, padding: '12px 14px', background: C.infoBg, borderRadius: R.lg, display: 'flex', gap: 12, alignItems: 'center' }}>
              <div style={{ fontSize: 22, lineHeight: 1, flexShrink: 0 }}>🛵</div>
              <div style={{ minWidth: 0, flex: 1 }}>
                <p style={{ fontSize: 13, fontWeight: 800, color: C.info, letterSpacing: -0.1 }}>Arriving in {o.eta}</p>
                {o.rider && <p style={{ fontSize: 12, color: C.textMed, marginTop: 2 }}>Rider · {o.rider.name}</p>}
              </div>
            </div>
          )}
        </Card>
        <Card>
          <p style={{ fontSize: 11, fontWeight: 800, color: C.textMed, marginBottom: 16, letterSpacing: 0.6 }}>STATUS TIMELINE</p>
          {stepOrder.map((step, i) => {
            const ev = o.timeline?.find(e => e.s === step);
            const done = i < curIdx || (i === curIdx && o.status === 'delivered');
            const current = i === curIdx && o.status !== 'delivered';
            const last = i === stepOrder.length - 1;
            return (
              <div key={step} style={{ display: 'flex', gap: 14, position: 'relative' }}>
                {!last && <div style={{ position: 'absolute', left: 11, top: 24, width: 2, height: 'calc(100% - 4px)', background: done ? C.primary : '#e7e5e4', transition: 'background .3s' }} />}
                <div style={{ width: 24, height: 24, borderRadius: 12, background: done || current ? C.primary : '#e7e5e4', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: done || current ? C.white : C.textLight, fontSize: 11, fontWeight: 800, marginTop: 1, boxShadow: current ? `0 0 0 4px rgba(12,192,223,.18)` : 'none', transition: 'box-shadow .25s' }}>
                  {done ? '✓' : current ? <span className="pulse">●</span> : ''}
                </div>
                <div style={{ flex: 1, paddingBottom: last ? 0 : 18, minWidth: 0 }}>
                  <p style={{ fontSize: 14, fontWeight: done || current ? 700 : 500, color: done || current ? C.text : C.textMed, letterSpacing: -0.1 }}>{labels[step]}</p>
                  {ev?.t && <p style={{ fontSize: 11, color: C.textMed, marginTop: 2, fontVariantNumeric: 'tabular-nums' }}>{ev.t}</p>}
                  {current && !ev?.t && <p style={{ fontSize: 11, color: C.primary, marginTop: 2, fontWeight: 700 }}>In progress…</p>}
                </div>
              </div>
            );
          })}
        </Card>
        <Card>
          <p style={{ fontSize: 11, fontWeight: 800, color: C.textMed, marginBottom: 12, letterSpacing: 0.6 }}>ITEMS</p>
          {o.items.map((item, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: i < o.items.length - 1 ? 8 : 0, gap: 12 }}>
              <span style={{ fontSize: 13, color: C.text, minWidth: 0, flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {item.name} <span style={{ color: C.textMed }}>× {item.qty}</span>
              </span>
              <span style={{ fontSize: 13, fontWeight: 700, color: C.text, fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>{fmt(item.lineP)}</span>
            </div>
          ))}
          <Divider my={12} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <span style={{ fontSize: 14, fontWeight: 800, color: C.text, letterSpacing: -0.1 }}>Total paid</span>
            <span style={{ fontSize: 15, fontWeight: 800, color: C.primary, fontVariantNumeric: 'tabular-nums', letterSpacing: -0.2 }}>{fmt(o.totalP)}</span>
          </div>
        </Card>
        {canCancel && (
          <Card style={{ background: '#fff8f4', border: `1px solid ${C.primaryLight}` }} elevation="flat">
            <p style={{ fontSize: 13, fontWeight: 800, color: C.text, marginBottom: 4, letterSpacing: -0.1 }}>Cancel this order?</p>
            <p style={{ fontSize: 12, color: C.textMed, marginBottom: 12, lineHeight: 1.5 }}>Orders can be cancelled before they go out for delivery. Refund within 3–5 business days.</p>
            <Btn full danger outline onClick={() => { if (window.confirm('Cancel this order? Refund will be processed within 3–5 business days.')) setCancelled(true); }}>Cancel order</Btn>
          </Card>
        )}
        {cancelled && (
          <div style={{ padding: '14px 16px', background: C.errorBg, borderRadius: R.xl, border: `1px solid ${C.error}` }}>
            <p style={{ fontSize: 13, fontWeight: 800, color: C.error, marginBottom: 4, letterSpacing: -0.1 }}>Order cancelled</p>
            <p style={{ fontSize: 12, color: C.textMed, lineHeight: 1.5 }}>Refund of <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 700, color: C.text }}>{fmt(o.totalP)}</span> will reflect in 3–5 business days.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export const BookingDetailScreen = ({ booking: b, goBack }) => {
  const [cancelled, setCancelled] = useState(false);
  return (
    <div className="fade-in" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <BkHdr title="Booking detail" onBack={goBack} />
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px 16px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {cancelled && (
          <div style={{ padding: '14px 16px', background: C.errorBg, borderRadius: R.xl, border: `1px solid ${C.error}` }}>
            <p style={{ fontSize: 13, fontWeight: 800, color: C.error, letterSpacing: -0.1 }}>Booking cancelled</p>
            {b.advancePaidP > 0 && <p style={{ fontSize: 12, color: C.textMed, marginTop: 4, lineHeight: 1.5 }}>Refund of <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 700, color: C.text }}>{fmt(b.advancePaidP)}</span> within 3–5 business days.</p>}
          </div>
        )}
        <Card>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 11, fontWeight: 700, color: C.textMed, letterSpacing: 0.4, fontVariantNumeric: 'tabular-nums' }}>#{b.id}</span>
            <SPill status={cancelled ? 'cancelled' : b.status} />
          </div>
          <p style={{ fontSize: 17, fontWeight: 800, color: C.text, marginBottom: 4, letterSpacing: -0.3 }}>{b.branchName}</p>
          <p style={{ fontSize: 13, color: C.textMed }}>{b.service} · ⏱ {b.duration} min</p>
        </Card>
        <Card>
          {[['Date', b.date], ['Slot', b.slot], ['Total', fmt(b.totalP)], [b.advancePaidP > 0 ? 'Advance paid' : 'Payment', b.advancePaidP > 0 ? fmt(b.advancePaidP) : 'Pay at salon']].map(([l, v], i, arr) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: i < arr.length - 1 ? 10 : 0, gap: 12 }}>
              <span style={{ fontSize: 13, color: C.textMed }}>{l}</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: C.text, fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}>{v}</span>
            </div>
          ))}
        </Card>
        {b.cancelBy && !cancelled && (
          <div style={{ padding: '14px 16px', background: C.warningBg, borderRadius: R.lg, border: '1px solid #fde68a' }}>
            <p style={{ fontSize: 13, fontWeight: 800, color: '#92400e', marginBottom: 4, letterSpacing: -0.1 }}>Cancellation policy</p>
            <p style={{ fontSize: 12, color: '#a16207', lineHeight: 1.5 }}>Cancel by <b style={{ fontVariantNumeric: 'tabular-nums' }}>{b.cancelBy}</b> for a {b.advancePaidP > 0 ? 'full refund' : 'free cancellation'}.</p>
          </div>
        )}
        {b.withinWindow && !cancelled && b.status !== 'completed' && (
          <Btn full danger outline onClick={() => { const msg = 'Cancel this booking? ' + (b.advancePaidP > 0 ? 'Advance refunded within 3-5 days.' : 'No charge.'); if (window.confirm(msg)) setCancelled(true); }}>Cancel booking</Btn>
        )}
      </div>
    </div>
  );
};
